import React, { Component } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Form from "../../../../components/Forms/Form";
import {
  alphaNumeric,
  required
} from "../../../../components/Forms/validators";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import Uploader from "../../../../components/Uploader/uploader";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class TypeQuestionCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      // user: {},
      loading: false
    };
    this.enviar = this.enviar.bind(this);
    this.atualizar = this.atualizar.bind(this);
    this.error = this.error.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    const idUser = this.props.match.params.id;
    if (idUser) {
      this.setState(
        () => ({
          loading: true,
          id: idUser
        }),
        () => {
          axios
            .get(`${URL.api}evaluation/type_question/singleView/${idUser}`, {
              headers: { authorization: `Bearer ${this.props.user.token}` }
            })
            .then(resp => {
              this.setState(
                () => ({
                  typeQuestion: resp.data.data
                }),
                () => {
                  this.setState(() => ({
                    edit: true,
                    loading: false
                  }));
                },
                error => {
                  this.error(error.response.statusText);
                }
              );
            });
        }
      );
    }
  }

  enviar(value) {
    let obj = {
      name: value.name,
      image: this.state.image
    };
    if (this.state.image === undefined) {
      toastr.error(
        "Fail",
        "Favor fazer o envio da imagem no início da página."
      );
    } else {
      axios
        .post(`${URL.api}evaluation/type_question/insert`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp => {
          this.props.history.push("/typeQuestion/list");
        });
    }
  }

  atualizar(value) {
    let obj = {
      name: value.name,
      image: this.state.image,
      id: this.state.id
    };
    axios
      .post(`${URL.api}evaluation/type_question/update`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.props.history.push("/typeQuestion/list");
      });
  }

  done(uploads) {
    this.setState(() => ({
      image: uploads[0]
    }));
  }

  render() {
    const fields = [
      {
        name: "name",
        label: "Nome",
        type: "text",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: [required, alphaNumeric]
      }
    ];
    let buttons = [
      {
        name: "Enviar",
        submit: false,
        icon: "fa fa-cloud",
        iconSide: "left",
        custom: this.enviar,
        color: "primary"
      }
    ];

    return (
      <>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/TypeQuestion/list", to: "/TypeQuestion/list" }]}
        />
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <div>
            <Uploader
              type="Type_question"
              maxFiles={1}
              acceptedFileTypes={["image/*"]}
              allowMultiple
              labelIdle='Arraste e solte sua imagem ou <span class="filepond--label-action">procure</span>'
              done={uploads => this.done(uploads)}
            />
            <Form
              avatar
              fields={fields}
              back
              history={this.props.history}
              buttons={buttons}
              onSubmit={this.state.edit ? this.atualizar : this.enviar}
              initialValues={this.state.typeQuestion}
              edit={this.state.edit}
            />
          </div>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(TypeQuestionCreate);
